import { styled } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

export const FormControlLabelStyled = styled(FormControlLabel)(
  ({ theme, checked }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    height: '40px',
    padding: '0 24px 0 16px',
    marginBottom: theme.spacing(0.5),
    marginLeft: 0,
    marginRight: 0,
    borderRadius: '5px',
    border: `solid 1px ${theme.palette.colors.borderLine}`,
    backgroundColor: checked
      ? theme.palette.colors.selectedAndDetailBackground
      : theme.palette.colors.primaryBackground,

    '&.Mui-disabled': {
      backgroundColor: theme.palette.colors.secondaryDisabledBackground,
    },
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
      fontWeight: 500,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: theme.palette.colors.onSecondaryAndDetailBackground,

      '&.Mui-disabled': {
        color: theme.palette.colors.secondaryDisabledText,
      },
    },
  }),
);
